<template>
    <div class="">
        <table class="table align-items-center">
            <thead>
                <tr>
                    <th>Nombre</th>
                    <th>Tipo Descuento</th>
                    <th>Valor Descuento</th>
                </tr>
            </thead>
            
            <tbody>
                <tr v-for="(lista,index) in ListaRecubrimientosxDescuento" :key="index">
                    <td>{{ lista.Nombre }}</td>
                    <td>
                        <select name="TipoDescuento" id="TipoDescuento" v-model="lista.TipoDescuento" @change="setDefaultData(lista)" class="form-control form-select">
                            <option :value="0">Seleccione una opción</option>
                            <option :value="1">Descuento en porcentaje</option>
                            <option :value="2">Descuento en monto fijo</option>
                        </select>
                    </td>
                    <td>
                       <!-- <label v-if="parseInt(objMaterial.TipoDescuento) == 1" class="form-label" for="Descuento">% Descuento</label>
							<label v-else-if="parseInt(objMaterial.TipoDescuento) == 2" class="form-label" for="Descuento">Monto de descuento</label>
							<label v-else class="form-label" for="Descuento">Descuento</label>-->
                            
                            <input type="text" v-model="lista.ValDescuento" @input="validRango(lista); $onlyNums($event,lista,'ValDescuento'); " id="ValDescuento" :placeholder="tipoPlaceHolder(lista)" class="form-control" :disabled="lista.TipoDescuento == 0">
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>


export default {
    name:  "FormDescuentos",
    props:['poBtnSave'],
    components:{},
    data() {
        return {
            objArticuloWeb: {
                IdArticuloWeb: 0,
            },
            ListaRecubrimientosxDescuento:[],
            Emit: this.poBtnSave.EmitSeccion,
            errorvalidacion: [],
            ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
        }
    },

    methods :{
        Guardar() {
            let newRequest = {
                IdArticuloWeb: this.objArticuloWeb.IdArticuloWeb,
                listaArtixRecubrimientosDesc: this.ListaRecubrimientosxDescuento
            }

            this.$http.post('/artixrecubrimientodesc/save', newRequest)
            .then( res => {
                this.EjecutaConExito(res)

            }).catch( err => {
                this.EjecutaConError(err)
            });
        },

        EjecutaConExito(res){
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err){
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },

        Limpiar(){

        },

        setDefaultData(item){
            item.ValDescuento = '';
        },

        validRango(item){
            if(item.ValDescuento != ''){
                if( parseInt(item.TipoDescuento) == 1 ) {
                    if(item.ValDescuento <= 0 || item.ValDescuento > 100){
                        item.ValDescuento = '';
                        this.$toast.info('Solo se reciben valores mayores a 0 y maximo 100')
                    }
                }else if(parseInt(item.TipoDescuento) == 2) {
                    if(item.ValDescuento <= 0) {
                        item.ValDescuento = '';
                        this.$toast.info('Requiere de un valor mayor a 0')
                    }
                }else {

                }
            }
            
        },

        // OBTIENE POR API LOS RECUBRIMIENTOS DISPONIBLES PARA EL ARTICULO WEB
		getRecubrimientos() {

            this.ListaRecubrimientosxDescuento = [];
            let newRequest = {
                ArticuloWeb: this.objArticuloWeb,
            };

            this.$http.post('/artixrecubrimientodesc', newRequest)
            .then( res => {
                this.ListaRecubrimientosxDescuento = res.data.data;
                /*this.ListaRecubrimientos = res.data.data.map(item => 
                    ({
                        IdBisel: item.IdBisel,
                        Nombre: item.Nombre,
                        Clave: item.Clave,
                        SubRegistro: item.SubRegistro,
                        ReqArmazon: item.ReqArmazon,
                        Disponible: 'NO',
                    }) 
                );*/

            }).catch( err => {
                console.log(err);
            });
			
		},

        tipoPlaceHolder(item) {

            let txt = '';
            if(item.TipoDescuento == 1){
                txt = '1 - 100%';
            }else if (item.TipoDescuento == 2) {
                txt = '$0.00';
            }else {
                txt = 'Ingresa un valor'
            }
            return txt;
        }
    },
    created() {
        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$off('Save_'+this.Emit);

         this.bus.$on('Recovery_'+this.Emit,(Id,Obj)=>{
            // console.log(Obj);
            this.ConfigLoad.ShowLoader=true;
            this.Limpiar();

            this.objArticuloWeb = Obj;
           
            if (this.objArticuloWeb.IdArticuloWeb>0) {
                this.getRecubrimientos();
            }
            else{
                this.ConfigLoad.ShowLoader=false;
            }

            this.bus.$on('Save_'+this.Emit,()=>{
                this.Guardar();
            });
            
        });

        
    }
}
</script>
